import {call, select} from "redux-saga/effects";
import {ILevelMapAggregatedTile} from "../../types";
import {handleQuestionTile} from "./handleQuestionTile";
import {IApplicationState} from "../../../index";
import {showConfirmationDialog} from "../../../dialog-manager/dialogs/showConfirmationDialog";
import i18n from "../../../../shared/i18n";

export function* handleExitTile(tile: ILevelMapAggregatedTile) {
    const {answeredTileCount, tileCount} = yield select(({ game }: IApplicationState) => ({
        answeredTileCount: game.levelMapProgress[game.levelInProgress].answeredTileCount,
        tileCount: game.levelMaps[game.levelInProgress].tileCount
    }));

    if (answeredTileCount < tileCount - 1) {
        const isConfirmed = yield call(showConfirmationDialog, i18n("gameplay.levelmap.finishlevelconfirmation"));
        if (isConfirmed)
            return;
    }

    return yield call(handleQuestionTile, tile);
}